<template lang="pug">
.f-content-restrictions
  label {{ label }}
  .input-wrapper
    w-switch( 
      label='Public'
      v-model='restrictions.public'
      @input='input'
    )
    w-switch( 
      v-model='restrictions.private'
      label='Private'
      :disabled='restrictions.public'
      @input='input'
    )
    w-switch( 
      v-model='restrictions.auth'
      label='Logged-in user'
      :disabled='restrictions.public'
      @input='input'
    )
    w-switch( 
      v-model='restrictions.members'
      label='VIP members'
      :disabled='restrictions.public'
      @input='input'
    )
    w-switch( 
      v-model='restrictions.premium'
      label='Premium members'
      :disabled='restrictions.public'
      @input='input'
    )
    w-switch( 
      v-model='restrictions.payperview'
      label='Pay-per-view'
      :disabled='restrictions.public'
      @input='input'
    )
    f-users(
      :value='restrictions.users'
      label='Specific users'
      :disabled='restrictions.public'
      @input='updateUsers'
    )
  .extra
    label Related content
    .input-wrapper
      //-TODO: link to product if not public
    f-media(
      v-model='restrictions.preview'
      label='Preview'
      :single='true'
      :disabled='restrictions.public'
      @input='input'
    )
</template>

<script lang="js">
import FModel from '@/fields/f-model'
import FMedia from '@/fields/f-media'
import FUsers from '@/fields/f-users'
import WSwitch from '@/widgets/w-switch'

export default {
  name: 'ContentRestrictionsField',
  mixins: [],
  components: { FModel, FMedia, FUsers, WSwitch },
  props: {
    label: {
      type: String,
      default: 'Content Restrictions'
    },
    value: {
      type: Object,
      default: () => ({
        public: false,
        private: true,
        auth: false,
        members: false,
        payperview: false,
        premium: false,
        plus: false,
        product: null,
        users: [],
        preview: null,
        show: false,
      })
    }
  },
  data() {
    return {
      restrictions: {},
    }
  },
  created() {
    this.setRestrictions( this.value )
  },
  mounted() {},
  methods: {
    setRestrictions( value ) {
      this.restrictions = Object.assign({
        public: false,
        private: true,
        auth: false,
        members: false,
        payperview: false,
        premium: false,
        plus: false,
        product: null,
        users: [],
        preview: null,
        show: false,
      }, this.value )
    },
    updateUsers( users ) {
      this.restrictions.users = users
      this.input()
    },
    input() {
      this.$emit( 'input', this.restrictions )
    },
  },
  computed: {},
  watch: {
    value( restrictions ) {
      this.setRestrictions( restrictions )
    }
  }
}
</script>

<style lang="scss">
.f-content-restrictions {
  --m-input: var(--s-xs);
  color: var(--c-fg);
  > label, > .extra > label {
    font-size: 0.8125em;
  }
  .label {
    font-size: unset;
  }
  /* > .w-switch { */
  /*   margin-bottom:  */
  /* } */
}
</style>
